export enum AppName {
  OcbApp = "stream-ocb-app",
  MenuApp = "stream-menu-app",
  Cropper = "stream-cropper-tauri2"
}

export enum Platform {
  Windows = "windows"
  // Darwin = "darwin",
  // Linux = "linux"
}

export interface ReleaseAsset {
  name: string
  s3Key: string
  size: number
  platform: Platform
  contentType: string
  githubAssetId: number
  signature?: string
}

export interface Release {
  id: string
  appName: AppName
  version: string
  githubReleaseId: number
  tagName: string
  assets: ReleaseAsset[]
  releaseNotes: string
  publishedAt: Date
  prerelease: boolean
  draft: boolean
  githubUrl: string
  syncedAt: Date
  createdAt: Date
  updatedAt: Date
}

export interface Pagination {
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface ReleasesListResponse {
  data: Release[]
  pagination: Pagination
}

export interface DownloadUrlResponse {
  url: string
  expiresIn: number
  filename: string
}

export interface SyncError {
  app: string
  version: string
  error: string
  timestamp: Date
}

export interface SyncResponse {
  success: boolean
  syncedReleases: number
  newReleases: number
  updatedReleases: number
  errors: SyncError[]
}
